export default __webpack_public_path__ + "locales/lo-LA/UploadPanel.json?hash=96c16f70fcdae2c775e16f62f090bf55";